export const Logo = ({ light = false, className = "" }) => {
  const ink = light ? "#FAF8F5" : "#1C2826";
  return (
    <span className={`inline-flex items-center gap-3 ${className}`}>
      <svg viewBox="0 0 40 48" className="h-10 w-auto shrink-0" aria-hidden="true">
        <path d="M4 46V20a16 16 0 0 1 32 0v26" fill="none" stroke="#B39158" strokeWidth="1.4" />
        <path d="M9 46V21a11 11 0 0 1 22 0v25" fill="none" stroke={ink} strokeOpacity="0.25" strokeWidth="0.8" />
        <text x="20" y="38" textAnchor="middle" fontFamily="Cormorant Garamond, Georgia, serif" fontSize="15" fill={ink}>RC</text>
      </svg>
      <span className="leading-tight">
        <span className={`block text-[0.62rem] font-semibold uppercase tracking-[0.3em] ${light ? "text-[#D9C193]" : "text-[#8C6D3A]"}`}>RC Avocats</span>
        <span className="font-serif-d block text-[1.15rem] tracking-tight" style={{ color: ink }}>Pauline Rège Chanal</span>
        <span className={`block text-[0.62rem] uppercase tracking-[0.16em] min-[400px]:tracking-[0.26em] ${light ? "text-[#E5DEC9]" : "text-[#5b6763]"}`}>Avocate · Barreau d'Aix-en-Provence</span>
      </span>
    </span>
  );
};
